import type React from 'react';

interface DurationBadgeProps {
  duration: number; // in minutes
  className?: string;
  variant?: 'default' | 'compact';
}

export const DurationBadge: React.FC<DurationBadgeProps> = ({
  duration,
  className = '',
  variant = 'default'
}) => {
  const formatDuration = (minutes: number): string => {
    if (minutes < 60) {
      return `${minutes}min`;
    }
    
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    
    if (variant === 'compact') {
      return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
    }
    
    if (remainingMinutes === 0) {
      return hours === 1 ? '1 hour' : `${hours} hours`;
    }
    
    return `${hours}h ${remainingMinutes}min`;
  };

  const getColorClass = (minutes: number): string => {
    if (minutes <= 15) {return 'bg-green-100 text-green-800 border-green-200';}
    if (minutes <= 30) {return 'bg-blue-100 text-blue-800 border-blue-200';}
    if (minutes <= 60) {return 'bg-yellow-100 text-yellow-800 border-yellow-200';}
    return 'bg-orange-100 text-orange-800 border-orange-200';
  };

  return (
    <span
      className={`
        inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border
        ${getColorClass(duration)}
        ${className}
      `}
    >
      <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
          clipRule="evenodd"
        />
      </svg>
      {formatDuration(duration)}
    </span>
  );
};